// angular
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  catchError,
  from,
  mergeMap,
  Observable,
  throwError,
  timeout,
} from 'rxjs';
import { inject } from '@angular/core';
// services
import { UserService } from '@shared/services/user.service';
import { StorageService } from '@shared/services/storage.service';
// environment
import { environment } from '@environments/environment';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

export const AuthorizationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const userService: UserService = inject(UserService);
  const storageService: StorageService = inject(StorageService);

  const TIMEOUT_DURATION = 15000; // Set timeout duration in milliseconds

  if (req.headers.has(InterceptorSkipHeader)) {
    const headers = req.headers.delete(InterceptorSkipHeader);
    return next(req.clone({ headers }));
  }

  return from(userService.getToken()).pipe(
    mergeMap(token => {
      if (!token) {
        if (!environment.production) {
          token = storageService.getToken() || '';
        } else {
          return next(req);
        }
      }
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          origin: environment.baseUrl.base,
        },
      });

      if (req.method === 'GET') {
        return next(req).pipe(
          timeout(TIMEOUT_DURATION),
          catchError((error: HttpErrorResponse) => {
            if (error.name === ('TimeoutError' as any)) {
              console.error('Request timed out');
            }
            return throwError(error);
          })
        );
      } else {
        return next(req);
      }
    })
  );
};
